module.exports = __webpack_public_path__ + "img/low-set.3510dd09.jpg";